export default function Inactive(props) {
  return (
    <div>
      <p>{props.values.user}</p>
    </div>
  );
}
